import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'
import { createFtpProfile } from 'utils/api/ftpProfileApi'
import { createFtpProfileSchema } from 'utils/schema/ftpProfileSchema'
import { PAGE_FTP_PROFILE } from 'utils/constants'
import { Button } from 'components/common'
import { FtpProfileDetailsForm } from 'components/ftpProfiles'
import { FtpProfileFormData } from 'components/ftpProfiles/utils'
import BackButton from 'components/backButton'
import { useNavigate } from 'react-router-dom'

const CreateFtpProfile = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<FtpProfileFormData>({
    resolver: yupResolver(createFtpProfileSchema),
  })

  const navigate = useNavigate()

  const handleCreateFtpProfile = async (data: FtpProfileFormData) => {
    const toastFtpProfile = toast.loading('Creating FTP profile...')

    try {
      await createFtpProfile(data)
      reset()
      toast.success('FTP profile created successfully', {
        id: toastFtpProfile,
      })
      navigate(PAGE_FTP_PROFILE.path)
    } catch (error) {
      toast.error('Failed to create FTP profile', { id: toastFtpProfile })
    }
  }

  return (
    <>
      <BackButton />

      <form onSubmit={handleSubmit(handleCreateFtpProfile)}>
        <FtpProfileDetailsForm
          register={register}
          errors={errors}
          setValue={setValue}
          control={control}
        />

        <Button buttonText="Create FTP Profile" className="mt-7 w-44" />
      </form>
    </>
  )
}

export default CreateFtpProfile
